import request from '@/utils/request'
let baseURL = '/mall-order';

// 预览下单
export function previewOrder(data) {
  return request({
    url: '/api/user/v1/buyNow/previewOrder',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
  buyCount (integer): 购买数量 ,
  goodsId (integer): 商品ID ,
  goodsVersionNo (integer): 商品快照版本号 ,
  integralUsed (number, optional): 抵扣支付所使用的金币数量 ,
  productId (integer): 货品ID ,
  shopId (integer): 店铺ID
}
*/

// 立即下单
export function placeOrder(data) {
  return request({
    url: '/api/user/v1/buyNow/placeOrder',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
buyCount (integer): 购买数量 ,
goodsId (integer): 商品ID ,
goodsVersionNo (integer): 商品快照版本号 ,
integralUsed (number, optional): 抵扣支付所使用的金币数量 ,
previewActualAmount (number): 预览应付金额 ,
previewDiscountAmount (number): 预览优惠金额（含金币抵扣支付金额） ,
previewOrderAmount (number): 预览订单金额 ,
productId (integer): 货品ID ,
shopId (integer): 店铺ID
}
*/

// 用户商品订单
// export function listOrder(data) {
//   return request({
//     url: '/api/user/v1/listOrder',
//     method: 'post',
//     baseURL,
//     data
//   })
// }
/*
{
orderMergeId (string, optional): 合并订单ID，使用订单号工具类生成，非自增ID。订单号=MG+订单ID ,
orderStatusMerge (string, optional): 订单状态：WAIT-待支付；SPIT_PAY-拆分支付；TIMEOUT-支付超时；PAID-已支付；PARTIAL_REFUND-订单部分商品退款；ORDER_REFUND-整个订单退款
                 = ['WAIT', 'CANCELLED', 'SPIT_PAY', 'TIMEOUT', 'PAID', 'PARTIAL_REFUND', 'ORDER_REFUND'],
orderType (string, optional): 订单类型：KN-知识订单；SH-店铺付费订单 = ['KN', 'SH'],
page (integer, optional),
size (integer, optional)
}
* */

// 用户订单列表、订单详情V2(同时请求多个订单类型)
export function listOrder(data) {
  return request({
    url: '/api/user/v2/listOrder',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
orderMergeId (string, optional): 合并订单ID，使用订单号工具类生成，非自增ID。订单号=MG+订单ID ,
orderStatusMerge (string, optional): 订单状态：WAIT-待支付；SPIT_PAY-拆分支付；TIMEOUT-支付超时；PAID-已支付；PARTIAL_REFUND-订单部分商品退款；ORDER_REFUND-整个订单退款 = ['WAIT', 'CANCELLED', 'SPIT_PAY', 'TIMEOUT', 'PAID', 'PARTIAL_REFUND', 'ORDER_REFUND'],
orderTypes (Array[string]): 订单类型：KN-知识订单；SH-店铺付费订单；SM-店铺会员礼包订单 ,
page (integer, optional),
size (integer, optional)
}
* */



// 立即购买--下单（购买会员，成为会员赠送会员礼包内的商品）
export function placeShopMemberOrder(data) {
  return request({
    url: '/api/user/v1/buyNow/placeShopMemberOrder',
    method: 'post',
    baseURL,
    data
  })
}
/*
 {
inviteUserOpenId (string, optional): 邀请用户OPEN_ID ,
shopId (integer): 店铺ID
}
* */

//------------------------- 京东相关 -------------------------
//获取购物车商品数量
export function countCartItems() {
  return request({
    url: '/api/cart/user/v1/countCartItems',
    method: 'post',
    baseURL,
  })
}

//查询购物车商品列表
export function listCartItems() {
  return request({
    url: '/api/cart/user/v1/listCartItems',
    method: 'post',
    baseURL,
  })
}

//添加商品到购物车（批量）
export function addToCart(data) {
  return request({
    url: '/api/cart/user/v1/addToCart',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
items (Array[ReqCartItem]): 添加到购物车的商品列表
}
ReqCartItem {
goodsId (integer): 商品ID ,
goodsType (string): 商品类型：JD_GOODS-京东商品 ,
priceWhenAdded (number): 加入购物车时的价格（非实时价格） ,
productCode (string, optional): 货品编号(SKU)。有SKU的商品必传，添加到购物车时拿不到SKU数据应反馈后台处理 ,
productCount (integer, optional): 商品数量 ,
productId (integer): 货品ID ,
shopId (integer): 店铺ID ,
shopSysType (string): 店铺系统类型：SHOP_SYS_TYPE_GOODS-店铺系统类型:商品类
}
* */


//从购物车删除商品
export function removeFromCart(data) {
  return request({
    url: '/api/cart/user/v1/removeFromCart',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
cartIds (Array[integer]): 要删除的购物车ID列表
}
* */

//修改购物车商品数量
export function updateCount(data) {
  return request({
    url: '/api/cart/user/v1/updateCount',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
cartId (integer): 购物车ID ,
productCount (integer): 数量
}
* */

// 实物商品下单（含购物车下单和立即购买）
export function placeGoodsOrder(data) {
  return request({
    url: '/api/user/v1/buyNow/placeGoodsOrder',
    method: 'post',
    baseURL,
    data
  })
}

/*
{
  "jdLogisticsInfo": {
    "installDate": 0,
    "needInstall": false,
    "promiseDate": "string",
    "promiseTimeRange": "string",
    "promiseTimeRangeCode": 0,
    "reservingDate": 0
  },
  "shopGoodsList": [
    {
      "goodsList": [
        {
          "count": 0,
          "goodsId": 0,
          "goodsType": "KNOWLEDGE",
          "inviteUserId": "string",
          "productCode": 0,
          "productId": 0
        }
      ],
      "memberPriceUsed": false,
      "shopId": 0
    }
  ],
  "userAddressId": 0
}


ReqPlaceGoodsOrder {
  jdLogisticsInfo (OrderJdLogisticsVO): 京东订单配送信息 ,
  shopGoodsList (Array[OrderShopGoodsVO]): 店铺商品列表 ,
  userAddressId (integer): 用户地址ID
}
OrderJdLogisticsVO {
  installDate (integer, optional): 大家电安装日期 不支持默认按-1处理，0表示当天，1表示明天，2：表示后天 ,
  needInstall (boolean, optional): 大家电是否选择了安装 是否选择了安装，默认为true，选择了“暂缓安装”，此为必填项，必填值为false ,
  promiseDate (string, optional): 中小件配送预约日期 格式：yyyy-MM-dd ,
  promiseTimeRange (string, optional): 中小件配送预约时间段 时间段如： 9:00-15:00 ,
  promiseTimeRangeCode (integer, optional): 中小件预约时间段的标记 ,
  reservingDate (integer, optional): 大家电配送日期 默认值为-1，0表示当天，1表示明天，2：表示后天; 如果为-1表示不使用大家电预约日历
}
OrderShopGoodsVO {
  goodsList (Array[OrderGoodsVO]): 店铺商品列表 ,
  memberPriceUsed (boolean): 是否使用会员价 ,
  shopId (integer): 店铺ID
}
OrderGoodsVO {
  count (integer): 购买数量 ,
  goodsId (integer): 商品ID ,
  goodsType (string): 商品类型：JD_GOODS-京东商品 = ['KNOWLEDGE', 'JD_GOODS', 'JD_BOOK'],
  inviteUserId (string, optional): 邀请购买用户OPENID（通过点击分享链接进入商品详情页购买：立即购买时直接拿邀请人；添加到购物车再购买时，保存在购物车，从购物车中获取） ,
  productCode (integer, optional): 货品编号(SKU)。有SKU的商品（如京东商品）必传 ,
  productId (integer): 货品ID
}
* */


//取消订单（取消整个用户订单）
export function cancelOrder(data) {
  return request({
    url: '/api/user/v1/cancelOrder',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
orderNo (string, optional): 订单号
}
* */

//实物商品订单列表-用户
export function sgOrderList(data) {
  return request({
    url: '/api/user/v1/out/order/list',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
orderStatus (string, optional): 订单状态：WAIT-待支付；SPIT_PAY-拆分支付；TIMEOUT-支付超时；PAID-已支付；PARTIAL_REFUND-订单部分商品退款；ORDER_REFUND-整个订单退款 ,
page (integer, optional),
size (integer, optional)
}
* */

//实物商品订单详情-用户
export function sgOrderInfo(data) {
  return request({
    url: '/api/user/v1/out/order/info',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
orderMergeId (integer, optional): 主单订单号 ,
}
* */

//实物商品订单物流列表-用户
export function deliveryList(data) {
  return request({
    url: '/api/user/v1/out/delivery/list',
    method: 'post',
    baseURL,
    data
  })
}
/*
{
orderMergeId (integer, optional): 主单订单号 ,
}
* */



